import { Box, CircularProgress } from '@mui/material';
import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { useBakerUserPermissions } from './useBakerUserPermissions';
import { PermissionDenied } from './PermissionDenied';

type Props = {
  children?: ReactNode;
  isAllowed?: boolean;
};

export const BakerUserPermissionsGuard = ({ isAllowed, children }: Props) => {
  const { loading } = useBakerUserPermissions();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
        data-testid="baker-user-permissions-guard-loader"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAllowed) {
    return <PermissionDenied />;
  }

  return children ? children : <Outlet />;
};
